<template>
    <div class="key" v-on="valid ? { click: openKey } : {}" :class="valid ? 'key-valid': 'key-expired'">
        <svg class="key-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" height="32" width="32">
            <path d="M11.667 23q-1.25 0-2.125-.875T8.667 20q0-1.25.875-2.125T11.667 17q1.25 0 2.125.875T14.667 20q0 1.25-.875 2.125T11.667 23Zm0 7Q7.5 30 4.583 27.083 1.667 24.167 1.667 20t2.916-7.083Q7.5 10 11.667 10q2.916 0 5.187 1.396 2.271 1.396 3.563 4.062h14.791L40 20.292l-7.125 6.75-3.583-2.625-3.542 2.625-3.25-2.5h-2.083q-1.125 2.416-3.375 3.937T11.667 30Zm0-2.792q2.375 0 4.333-1.541 1.958-1.542 2.542-3.917h4.916l2.292 1.833 3.583-2.625 3.25 2.5L36 20.208l-1.958-1.958h-15.5q-.542-2.292-2.459-3.875-1.916-1.583-4.416-1.583-3 0-5.105 2.104Q4.458 17 4.458 20t2.104 5.104q2.105 2.104 5.105 2.104Z"/>
        </svg>

        <div class="key-text">
            <h4>Access key</h4>
            <p class="small-text">{{ access_key }}</p>
            <p class="small-text" :class="{'p-valid' : valid}">{{ key_desc }}</p>
            <p v-if="valid" class="small-text p-valid">Expires on: {{ expiry_time }}</p>
            <p v-else class="small-text">Expired</p>
        </div>
        <button v-if="!valid" class="unstyled-button delete-button"  @click="deleteClicked">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#757575">
                <path d="M7.3 20.5q-.75 0-1.275-.525Q5.5 19.45 5.5 18.7V6h-1V4.5H9v-.875h6V4.5h4.5V6h-1v12.7q0 .75-.525 1.275-.525.525-1.275.525ZM17 6H7v12.7q0 .125.088.213.087.087.212.087h9.4q.1 0 .2-.1t.1-.2ZM9.4 17h1.5V8H9.4Zm3.7 0h1.5V8h-1.5ZM7 6V19v-.3Z"/>
            </svg>
        </button>
    </div>
</template>


<script>
    export default {
        name: 'AccessKey',
        props: {
            valid: Boolean, /**styling depends on this */
            prjnum: String,
            access_key: String,
            key_desc: String,
            expire: Number
        },
        emits: ['delete-clicked', 'open-key'],
        methods: {
            deleteClicked() {
                this.emitter.emit('delete-clicked', {prjnum: this.prjnum, access_key: this.access_key, isActive: false}); //only expired keys deleted here
            },
            openKey() {
                this.$emit('open-key', this.access_key);
            },

        },
        computed: {
            expiry_time() {
                let date = new Date(this.expire*1000).toString();
                date = date.slice(3);
                return date.split(' (')[0];
            }
        }    
    }
</script>

<style scoped>

.key {
    border: 2px solid var(--blue-gray);
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    margin-top: 0.5rem;
}

.key-valid:hover {
    background-color: var(--light-blue);
    cursor: pointer;
}

.key-valid svg {
    fill: var(--blue);
}

.key-expired {
    border: none;
    background-color: var(--light-gray);
    color: var(--darker-gray);
}

.key-expired svg {
    fill: var(--darker-gray);
}

.key-text {
    margin-top: 0.7rem;
    margin-bottom: 1rem;
}

.p-valid {
    color: var(--petrol-gray);
}

.key-text p, .key-text h4 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}

.key-icon {
    min-width: 2rem;
    margin-left: 1rem;
    padding: 0.5rem;
}

.delete-button {
    padding: 0.5rem;
    margin-left: auto;
    margin-right: 1rem;
    background-color: var(--light-gray);
}

.delete-button svg:hover {
    fill: var(--black);
}
</style>